module.exports = __webpack_public_path__ + "static/yelobankmedia-4a2ab9d9b17a780f78a840588b7816f7.jpg";